import React from 'react'
import ReactTable from 'react-table';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Label,
    FormFeedback,
    FormGroup,
    Input,
    CardTitle,
} from "reactstrap";
function TicketProductList(props) {
    return (
        <div
            className={
                props.filteredProductList.length > 0 ? "scrollbar " : " "
            }
        >
            {props.filteredProductList.length > 0 ? (
                props.filteredProductList.map((product) =>
                    props.asinForTicketList == product.asin ? (
                        <>
                            <Row className="m-0 p-0">
                                <Col md="1" className="mt-2 p-0">
                                    <div className="">
                                        <input
                                            className="mt-5 ml-4  "
                                            value={product.asin}
                                            type="checkbox"
                                            name={product.asin}
                                            onChange={props.handleChange}
                                            checked={
                                                props.asinForTicketList == product.asin ? true : false
                                            }
                                        />
                                    </div>
                                </Col>
                                <Col
                                    md="11"
                                    className="border row-background-color"
                                >
                                    <Row className="justify-content-center ">
                                        <Col md="1" className="">
                                            <div>
                                                <img
                                                    className="ml-0 mt-3"
                                                    width={"85px"}
                                                    src={product.itemImage}
                                                />
                                            </div>
                                        </Col>
                                        <Col md="11" className="p-2">
                                            <div>
                                                <h6>
                                                    <b>{product.productTitle}</b>
                                                </h6>
                                                <div className="">
                                                    <Row>
                                                        <Col md={5}>
                                                            <span>
                                                                <b>ASIN : </b>{" "}
                                                                {product.asin}
                                                            </span>
                                                        </Col>
                                                        <Col md={7}>
                                                            {/* <div>
                                            <DropdownWithCheckbox options={product.skus} onSelect={(values) => handleSelect(values, product.asin)} />
                                          </div> */}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </>
                    ) : props.asinForTicketList == "" ? (
                        <>
                            <Row className="m-0 p-0">
                                <Col md="1" className="mt-2 p-0">
                                    <div className="">
                                        <input
                                            className="mt-5 ml-4  "
                                            value={product.asin}
                                            type="checkbox"
                                            name={product.asin}
                                            onChange={props.handleChange}
                                            checked={props.asinArray.includes(product.asin) ? true : false}
                                        />
                                    </div>
                                </Col>
                                <Col
                                    md="11"
                                    className="border row-background-color"
                                >
                                    <Row className="justify-content-center ">
                                        <Col md="1" className="">
                                            <div>
                                                <img
                                                    className="ml-0 mt-3"
                                                    width={"85%"}
                                                    src={product.itemImage}
                                                />
                                            </div>
                                        </Col>
                                        <Col md="11" className="p-2">
                                            <div>
                                                <h6>
                                                    <b>{product.productTitle}</b>
                                                </h6>
                                                <div className="">
                                                    <Row>
                                                        <Col md={5}>
                                                            <span>
                                                                <b>ASIN : </b>{" "}
                                                                {product.asin}
                                                            </span>
                                                        </Col>
                                                        <Col md={7}>
                                                            {/* <div>
                                            <DropdownWithCheckbox options={product.skus} onSelect={(values) => handleSelect(values, product.asin)} />
                                          </div> */}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        ""
                    )
                )
            ) : (
                <p className="text-center">
                    {" "}
                    No product available.
                </p>
            )}
        </div>
    )
}

function LargeProductList(props) {
    const columns = [
        {
            Header: "Select",
            accessor: "asin",
            width:80,
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                
                <input
                
                value={cellInfo.value}
                type="checkbox"
                name={cellInfo.value}
                onChange={props.handleChange}
                checked={props.asinArray.includes (cellInfo.value) ? true : false}
            />
              </div>
            ),
          },
        {
          Header: "Asin",
          accessor: "asin",
          width: 200,
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-center w-100">
              
              <p className='mb-0'>{cellInfo.value}</p>
            </div>
          ),
        },
        {
          Header: "Product Title",
          accessor: "productTitle",
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-start w-100">
              <p className='mb-0'>{cellInfo.value}</p>
            </div>
          ),
        },
        ]
    
   

    return (
        <>
        <Col className='mt-2'>
            <ReactTable
                  data={props.filteredProductList}
                  columns={columns}
                  className="-fixed -highlight -striped mt-2"
                  getTheadProps={() => {
                    return {
                      style: {
                        overflowY: "hidden",
                        background: "#B1FA63",
                        color: "#243837",
                      },
                    };
                  }}
                  defaultPageSize={5}
                  noDataText={"No Data Found."}
                />
                </Col>
        </>
    )
}
export { TicketProductList, LargeProductList }
